
import React, { useEffect } from "react";
import "./Privacy_Policy.css";
import Common_Title_1 from "../../../../common/common_components/common_title_1/Common_Title_1";
import Pink_Btn from "../../../../common/common_btn/pink_btn/Pink_Btn";
import { AllPrivacyPolicy } from '../../../../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";

const Privacy_Policy = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const privacy_policy = useSelector((state) => state.footer.privacy_policy);

  console.log("all_terms_conditionall_terms_condition", privacy_policy)

  useEffect(() => {
    dispatch(AllPrivacyPolicy());
  }, [dispatch]);


  return (
    <section className="Privacy_Policy">
      <Common_Title_1 subText="Privacy Policy" />

      <p className="">{parse(privacy_policy[0]?.content || "")}</p>

      <div className="btn_holder">
        <Pink_Btn btnText={"OK"} onClick={() => { navigate("/settings/menu") }} />
      </div>
    </section>
  );
};

export default Privacy_Policy;
